var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ManageOrganizationController_orgHash;
import { createFormFromSelector, JURL, urlJoin } from "../utils.js";
export class EWAController {
    constructor(client, baseUrl) {
        this.client = client;
        this.baseUrl = new JURL(baseUrl);
    }
}
export class ManageOrganizationController extends EWAController {
    constructor(client, baserUrl, organizationHash) {
        super(client, baserUrl);
        _ManageOrganizationController_orgHash.set(this, void 0);
        __classPrivateFieldSet(this, _ManageOrganizationController_orgHash, organizationHash, "f");
    }
    getEmployee(id) {
        return this.employee(id).get();
    }
    get pathToOrganizationResource() {
        return this.baseUrl.joinPath("/v1/manage/organizations", __classPrivateFieldGet(this, _ManageOrganizationController_orgHash, "f"))
            .href;
    }
    request(id) {
        return {
            /**
             *
             * @returns a
             */
            admin_confirm: () => __awaiter(this, void 0, void 0, function* () {
                yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/requests", id, "confirm"), {
                    method: "POST",
                });
                return;
            }),
            approve: () => __awaiter(this, void 0, void 0, function* () {
                yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/requests", id, "approve"), {
                    method: "POST",
                });
                return;
            }),
            reject: (reason) => __awaiter(this, void 0, void 0, function* () {
                const body = reason ? JSON.stringify({ reason }) : undefined;
                yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/requests", id, "reject"), {
                    method: "POST",
                    body,
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                return;
            }),
        };
    }
    queryRepayments() {
        return __awaiter(this, arguments, void 0, function* (params = {}) {
            const form = createFormFromSelector(params);
            const res = yield this.client.fetch(`${urlJoin(this.pathToOrganizationResource, "/query/repayments")}`, {
                method: "POST",
                body: form.toString(),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    // async queueRegisterEmployees(
    //   data: {
    //     name: string;
    //     jobTitle: string;
    //     netSalary: number;
    //     withdrawPercentage: number;
    //     withdrawBehaviour: string;
    //     phoneNumber: string;
    //     language: string;
    //     email?: string;
    //     kyu?: Record<string, any>;
    //   }[],
    //   opts?: {
    //     collisionKey: string;
    //     signal?: AbortSignal;
    //   },
    // ) {
    //   const headers = new Headers({ "Content-Type": "application/json" });
    //   if (opts?.collisionKey) {
    //     headers.set("Ewa-Message-Id", opts.collisionKey);
    //   }
    //   const res = await this.client.fetch(
    //     urlJoin(this.pathToOrganizationResource, "/employees"),
    //     {
    //       method: "POST",
    //       body: JSON.stringify({
    //         data: data,
    //         enabled: true,
    //         shouldNotify: true,
    //       }),
    //       signal: opts?.signal,
    //       headers: headers,
    //     },
    //   );
    //   if (!res.ok) {
    //     throw new WebError(res.status, "failed to send create request event");
    //   }
    //   return;
    // }
    getTerms() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/terms"));
            return (yield res.json());
        });
    }
    term(value) {
        if (value !== "active" && value["id"] === undefined) {
            throw new Error("argument as invalid shape. must either be \"active\" or have an input of shape { 'id': <termid> }");
        }
        const termId = value === "active" ? value : value.id;
        const termPath = urlJoin(this.pathToOrganizationResource, "/terms", termId);
        return {
            repaymentsQuery: () => __awaiter(this, void 0, void 0, function* () {
                const res = yield this.client.fetch(urlJoin(termPath, "/records"));
                return (yield res.json());
            }),
        };
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.client.fetch(this.pathToOrganizationResource, {
                method: "GET",
            });
            return (yield res.json());
        });
    }
    getPendingAdvancesOverview() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/statistics/repayments/pending/aggregate"));
            return (yield res.json());
        });
    }
    advance(id) {
        const advancePath = urlJoin(this.pathToOrganizationResource, "/advances", id);
        return {
            get: () => __awaiter(this, void 0, void 0, function* () {
                const res = yield this.client.fetch(advancePath);
                return (yield res.json());
            }),
            getSchedule: () => __awaiter(this, void 0, void 0, function* () {
                const res = yield this.client.fetch(urlJoin(advancePath, "schedule"));
                return (yield res.json());
            }),
            getPenalties: (referenceDate) => __awaiter(this, void 0, void 0, function* () {
                const q = new URLSearchParams();
                if (referenceDate) {
                    q.set("reference", referenceDate.toISOString());
                }
                const res = yield this.client.fetch(urlJoin(advancePath, "penalties"));
                return (yield res.json());
            }),
        };
    }
    // create advance request
    createAdvanceOrder(employeeId, data, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const advdata = {
                data,
                shouldNotify: (_a = opts.notify) !== null && _a !== void 0 ? _a : true,
            };
            console.log(advdata);
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/employees", employeeId, "/make-advance-request"), {
                method: "POST",
                body: JSON.stringify(advdata),
                headers: {
                    "Idempotent-Key": opts.idempotentKey,
                    "Content-Type": "application/json",
                },
            });
            return (yield res.json());
        });
    }
    employee(id) {
        return {
            get: () => __awaiter(this, void 0, void 0, function* () {
                const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/employees", id));
                return (yield res.json());
            }),
            previewAdvanceOrder: (data) => __awaiter(this, void 0, void 0, function* () {
                const body = data.type === "simple"
                    ? {
                        type: data.type,
                        requestedAmount: data.requestedAmount,
                    }
                    : {
                        type: data.type,
                        requestedAmount: data.requestedAmount,
                        repaymentPlan: data.repaymentPlan,
                    };
                const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/employees", id, "/preview-advance-request"), {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                return (yield res.json());
            }),
        };
    }
    /**
     * Get the statistics information for the organization
     */
    get statistics() {
        return {
            getOverview: () => __awaiter(this, void 0, void 0, function* () {
                const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/statistics/overview"));
                return (yield res.json());
            }),
        };
    }
    getActiveTerm() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/terms/active"));
            const data = (yield res.json());
            return Object.assign(Object.assign({}, data), { term_start_date: new Date(data.term_start_date), term_end_date: new Date(data.term_end_date) });
        });
    }
    getTerm(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/terms", id));
            const data = (yield res.json());
            return Object.assign(Object.assign({}, data), { term_start_date: new Date(data.term_start_date), term_end_date: new Date(data.term_end_date) });
        });
    }
    // async requestsQuery(
    //   params?: Partial<
    //     {
    //       select: Partial<
    //         Record<"requests" | "type" | "members", OneOrMany<string>> &
    //           Record<"status", OneOrMany<RequestsStatus>>
    //       >;
    //       limit: number;
    //       cursor: string;
    //     } & Record<"requested-date", RangeOrExact<string>> // These describe exact range
    //   >,
    // ) {
    //   const q = createFormFromSelector(params);
    //   const res = await this.client.fetch(
    //     urlJoin(this.pathToOrganizationResource, "/requests") +
    //       `?${q.toString()}`,
    //   );
    //   return (await res.json()) as {
    //     limit: number;
    //     total_size: string | number;
    //     count: number;
    //     next?: string;
    //     data: {
    //       id: string;
    //       member_name: string;
    //       member_iid: string;
    //       employee_id: string;
    //       requested_amount: MoneyInit;
    //       type: "installment_advance" | "simple_advance";
    //       status: RequestsStatus;
    //       associated_advance_id?: string | null;
    //       authorizing_manager_id?: string | null;
    //       requested_at: string;
    //       approved_at?: string | null;
    //       rejected_at?: string | null;
    //     }[];
    //   };
    // }
    repaymentsQuery(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = createFormFromSelector(params);
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/repayments") +
                `?${q.toString()}`);
            return (yield res.json());
        });
    }
    queryAdvances(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const formdata = createFormFromSelector(params);
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/query/advances"), {
                method: "POST",
                body: formdata,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            const out = (yield res.json());
            return out;
        });
    }
    queryRequests(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const formdata = createFormFromSelector(params);
            const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/query/requests"), {
                method: "POST",
                body: formdata,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    get employees() {
        return {
            query: () => __awaiter(this, void 0, void 0, function* () {
                const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/employees"));
                return (yield res.json());
            }),
            getStatistics: () => __awaiter(this, void 0, void 0, function* () {
                const res = yield this.client.fetch(urlJoin(this.pathToOrganizationResource, "/statistics/employees/aggregate"));
                return (yield res.json());
            }),
        };
    }
}
_ManageOrganizationController_orgHash = new WeakMap();
// Controller for the `Manager` object
export class ManagerController extends EWAController {
    // Get the organizations
    getOrganizations() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.client.fetch(this.baseUrl.joinPath("/v1/manage/organizations"));
            return (yield res.json());
        });
    }
    organization(urlHash) {
        return new ManageOrganizationController(this.client, this.baseUrl, urlHash);
    }
}
